var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#E5EDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4103 9.58887H9.58933C9.23154 9.59019 8.88889 9.73339 8.63655 9.98704C8.38421 10.2407 8.2428 10.5841 8.24333 10.9419L8.23633 19.0579C8.23738 19.4164 8.38027 19.7599 8.63378 20.0134C8.88729 20.2669 9.23081 20.4098 9.58933 20.4109H20.4103C20.7688 20.4098 21.1124 20.2669 21.3659 20.0134C21.6194 19.7599 21.7623 19.4164 21.7633 19.0579V10.9419C21.7623 10.5834 21.6194 10.2398 21.3659 9.98632C21.1124 9.73281 20.7688 9.58992 20.4103 9.58887ZM20.4103 12.2939L14.9993 15.6759L9.58933 12.2939V10.9419L15.0003 14.3239L20.4113 10.9419L20.4103 12.2939Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail2);
export default __webpack_public_path__ + "static/media/mail2.20698a22e968497d882dbdaa140a5911.svg";
export { ForwardRef as ReactComponent };